module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logout":"Logout","settings":"Settings"},"ja":{"logout":"ログアウト","settings":"マイページ"}}')
  delete Component.options._Ctor
}
